export function removeTrailingSlashes(filePath: string) {
  return filePath.replace(/\/+$/g, '');
}

export function sanitizePath(filePath: string) {
  return filePath.replace(/\/\/+/g, '/').replace(/\/+$/g, '');
}
